var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _mask, _path, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _mask2, _path2, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalysisIllustration = function SvgAnalysisIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324,
    height: 250,
    fill: "none",
    viewBox: "0 0 324 250"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AnalysisIllustration_svg__a)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#AnalysisIllustration_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 220,
    x: 21.957,
    y: 8.51,
    fill: "url(#AnalysisIllustration_svg__c)",
    rx: 1.737,
    shapeRendering: "crispEdges",
    transform: "rotate(3 21.957 8.51)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 219,
    x: 16.5,
    y: 16.5,
    fill: "url(#AnalysisIllustration_svg__d)",
    fillOpacity: 0.56,
    rx: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 219,
    x: 16.5,
    y: 16.5,
    stroke: "url(#AnalysisIllustration_svg__e)",
    rx: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 76,
    x: 208,
    y: 104,
    fill: "#516B89",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 120,
    x: 228,
    y: 60,
    fill: "#516B89",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 140,
    x: 248,
    y: 40,
    fill: "#516B89",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 132,
    x: 268,
    y: 48,
    fill: "#516B89",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 56,
    x: 208,
    y: 124,
    fill: "#8598AF",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 80,
    x: 228,
    y: 100,
    fill: "#8598AF",
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 140,
    x: 248,
    y: 40,
    fill: "#8598AF",
    rx: 2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 120,
    x: 268,
    y: 60,
    fill: "#8598AF",
    rx: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 16,
    x: 208,
    y: 196,
    fill: "#516B89",
    rx: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 4,
    x: 40,
    y: 40,
    fill: "#516B89",
    rx: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 4,
    x: 40,
    y: 48,
    fill: "#516B89",
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AnalysisIllustration_svg__f)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "AnalysisIllustration_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 106c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AnalysisIllustration_svg__g)",
    "data-figma-skip-parse": "true",
    mask: "url(#AnalysisIllustration_svg__h)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 2500,
    height: 2500,
    x: -1250,
    y: -1250,
    transform: "rotate(90 -17 89)scale(.032)"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,#516b89 0deg,#516b89 72deg,#8598af 72.0203deg,#8598af 179.564deg,#516b89 179.759deg,#516b89 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 106h-8c0 13.255-10.745 24-24 24v16c22.091 0 40-17.909 40-40zm-32 32v-8c-13.255 0-24-10.745-24-24H32c0 22.091 17.909 40 40 40zm-32-32h8c0-13.255 10.745-24 24-24V66c-22.091 0-40 17.909-40 40zm32-32v8c13.255 0 24 10.745 24 24h16c0-22.091-17.909-40-40-40z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.31764706969261169,\"g\":0.41960784792900085,\"b\":0.53725492954254150,\"a\":1.0},\"position\":0.20000000298023224},{\"color\":{\"r\":0.52156865596771240,\"g\":0.59607845544815063,\"b\":0.68627452850341797,\"a\":1.0},\"position\":0.20005635917186737},{\"color\":{\"r\":0.52156865596771240,\"g\":0.59607845544815063,\"b\":0.68627452850341797,\"a\":1.0},\"position\":0.49878969788551331},{\"color\":{\"r\":0.31764706969261169,\"g\":0.41960784792900085,\"b\":0.53725492954254150,\"a\":1.0},\"position\":0.49933129549026489},{\"color\":{\"r\":0.31764706969261169,\"g\":0.41960784792900085,\"b\":0.53725492954254150,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.31764706969261169,\"g\":0.41960784792900085,\"b\":0.53725492954254150,\"a\":1.0},\"position\":0.20000000298023224},{\"color\":{\"r\":0.52156865596771240,\"g\":0.59607845544815063,\"b\":0.68627452850341797,\"a\":1.0},\"position\":0.20005635917186737},{\"color\":{\"r\":0.52156865596771240,\"g\":0.59607845544815063,\"b\":0.68627452850341797,\"a\":1.0},\"position\":0.49878969788551331},{\"color\":{\"r\":0.31764706969261169,\"g\":0.41960784792900085,\"b\":0.53725492954254150,\"a\":1.0},\"position\":0.49933129549026489},{\"color\":{\"r\":0.31764706969261169,\"g\":0.41960784792900085,\"b\":0.53725492954254150,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":3.9188699282725371e-15,\"m01\":-64.0,\"m02\":104.0,\"m10\":64.0,\"m11\":3.9188699282725371e-15,\"m12\":74.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#AnalysisIllustration_svg__h)"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 40,
    y: 154,
    fill: "#516B89",
    rx: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 40,
    y: 162,
    fill: "#516B89",
    rx: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 40,
    y: 170,
    fill: "#516B89",
    rx: 2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 4,
    x: 48,
    y: 154,
    fill: "#516B89",
    rx: 2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 4,
    x: 48,
    y: 162,
    fill: "#516B89",
    rx: 2
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 4,
    x: 48,
    y: 170,
    fill: "#516B89",
    rx: 2
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "AnalysisIllustration_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184 106c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AnalysisIllustration_svg__i)",
    "data-figma-skip-parse": "true",
    mask: "url(#AnalysisIllustration_svg__j)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 2500,
    height: 2500,
    x: -1250,
    y: -1250,
    transform: "rotate(90 23 129)scale(.032)"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,#516b89 0deg,#516b89 89.9112deg,#8598af 90.0337deg,#8598af 324.951deg,#6b819c 324.987deg,#516b89 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184 106h-8c0 13.255-10.745 24-24 24v16c22.091 0 40-17.909 40-40zm-32 32v-8c-13.255 0-24-10.745-24-24h-16c0 22.091 17.909 40 40 40zm-32-32h8c0-13.255 10.745-24 24-24V66c-22.091 0-40 17.909-40 40zm32-32v8c13.255 0 24 10.745 24 24h16c0-22.091-17.909-40-40-40z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.31764706969261169,\"g\":0.41960784792900085,\"b\":0.53725492954254150,\"a\":1.0},\"position\":0.24975335597991943},{\"color\":{\"r\":0.52156865596771240,\"g\":0.59607845544815063,\"b\":0.68627452850341797,\"a\":1.0},\"position\":0.25009348988533020},{\"color\":{\"r\":0.52156865596771240,\"g\":0.59607845544815063,\"b\":0.68627452850341797,\"a\":1.0},\"position\":0.90264064073562622},{\"color\":{\"r\":0.41960784792900085,\"g\":0.50588238239288330,\"b\":0.61176472902297974,\"a\":1.0},\"position\":0.90274065732955933},{\"color\":{\"r\":0.31764706969261169,\"g\":0.41960784792900085,\"b\":0.53725492954254150,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.31764706969261169,\"g\":0.41960784792900085,\"b\":0.53725492954254150,\"a\":1.0},\"position\":0.24975335597991943},{\"color\":{\"r\":0.52156865596771240,\"g\":0.59607845544815063,\"b\":0.68627452850341797,\"a\":1.0},\"position\":0.25009348988533020},{\"color\":{\"r\":0.52156865596771240,\"g\":0.59607845544815063,\"b\":0.68627452850341797,\"a\":1.0},\"position\":0.90264064073562622},{\"color\":{\"r\":0.41960784792900085,\"g\":0.50588238239288330,\"b\":0.61176472902297974,\"a\":1.0},\"position\":0.90274065732955933},{\"color\":{\"r\":0.31764706969261169,\"g\":0.41960784792900085,\"b\":0.53725492954254150,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":3.9188699282725371e-15,\"m01\":-64.0,\"m02\":184.0,\"m10\":64.0,\"m11\":3.9188699282725371e-15,\"m12\":74.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#AnalysisIllustration_svg__j)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 120,
    y: 154,
    fill: "#516B89",
    rx: 2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 120,
    y: 162,
    fill: "#516B89",
    rx: 2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 120,
    y: 170,
    fill: "#516B89",
    rx: 2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 4,
    x: 128,
    y: 154,
    fill: "#516B89",
    rx: 2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 4,
    x: 128,
    y: 162,
    fill: "#516B89",
    rx: 2
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 4,
    x: 128,
    y: 170,
    fill: "#516B89",
    rx: 2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 16,
    x: 40,
    y: 196,
    fill: "#516B89",
    rx: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "AnalysisIllustration_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 106h-8c0 13.255-10.745 24-24 24v16c22.091 0 40-17.909 40-40zm-32 32v-8c-13.255 0-24-10.745-24-24H32c0 22.091 17.909 40 40 40zm-32-32h8c0-13.255 10.745-24 24-24V66c-22.091 0-40 17.909-40 40zm32-32v8c13.255 0 24 10.745 24 24h16c0-22.091-17.909-40-40-40z",
    mask: "url(#AnalysisIllustration_svg__h)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AnalysisIllustration_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184 106h-8c0 13.255-10.745 24-24 24v16c22.091 0 40-17.909 40-40zm-32 32v-8c-13.255 0-24-10.745-24-24h-16c0 22.091 17.909 40 40 40zm-32-32h8c0-13.255 10.745-24 24-24V66c-22.091 0-40 17.909-40 40zm32-32v8c13.255 0 24 10.745 24 24h16c0-22.091-17.909-40-40-40z",
    mask: "url(#AnalysisIllustration_svg__j)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AnalysisIllustration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h324v250H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "AnalysisIllustration_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 74h64v64H40z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AnalysisIllustration_svg__c",
    x1: 27.962,
    x2: 150.169,
    y1: 12.861,
    y2: 298.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111827",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AnalysisIllustration_svg__d",
    x1: 19.681,
    x2: 150.959,
    y1: 17.212,
    y2: 307.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#385677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "AnalysisIllustration_svg__e",
    x1: 275,
    x2: 209.219,
    y1: 236,
    y2: 72.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516B89",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("filter", {
    id: "AnalysisIllustration_svg__b",
    width: 448.99,
    height: 380.857,
    x: -62.495,
    y: -64.429,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 8.683,
    result: "effect1_dropShadow_6_242"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.815,
    dy: 10.42
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.645
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00392157 0 0 0 0 0.0431373 0 0 0 0 0.145098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_242"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_6_242",
    result: "shape"
  })))));
};
export default SvgAnalysisIllustration;